import React from 'react';
import { Link } from 'react-router-dom';
import './CompetitiveExams.css';
import { FaGraduationCap, FaFlask, FaCalculator, FaBrain, FaChartLine, FaStethoscope, FaArrowRight, FaPlus } from 'react-icons/fa';
import ShimmerButton from './ShimmerButton';

const CompetitiveExams = () => {
  const examCategories = [
    {
      title: "Defense Services Exams",
      icon: <FaGraduationCap />,
      description: "Premier coaching for national defense services entrance examinations.",
      exams: [
        "NDA (National Defence Academy)",
        "CDS (Combined Defence Services)",
        "AFCAT (Air Force Common Admission Test)",
        "Indian Navy Entrance Test"
      ]
    },
    {
      title: "Defence Schools & Colleges",
      icon: <FaGraduationCap />,
      description: "Specialized preparation for military schools and institutions.",
      exams: [
        "RIMC (Rashtriya Indian Military College)",
        "RMS (Rashtriya Military Schools)",
        "Sainik Schools",
        "Military Schools Entrance"
      ]
    },
    {
      title: "Defence Entry Programs",
      icon: <FaBrain />,
      description: "Specialized training for entry-level defense and security programs.",
      exams: [
        "Agniveer",
        "NCC Cadets",
        "Military Police (CMP)"
      ]
    },
    {
      title: "Engineering & Medical",
      icon: <FaFlask />,
      description: "Expert preparation for top engineering and medical entrance exams.",
      exams: [
        "JEE Main",
        "JEE Advanced",
        "NEET"
      ]
    },
    {
      title: "Law & University Exams",
      icon: <FaCalculator />,
      description: "Focused preparation for law and general university entrance tests.",
      exams: [
        "CLAT (Common Law Admission Test)",
        "CUET (Common University Entrance Test)",
        "MHTCET (Maharashtra Common Entrance Test)"
      ]
    },
    {
      title: "SSB Training",
      icon: <FaChartLine />,
      description: "Specialized training for Service Selection Board interviews and assessments.",
      exams: [
        "Psychology Tests",
        "Group Tasks",
        "Personal Interview Preparation",
        "GTO Tasks"
      ]
    },
    {
      title: "MEAP Framework",
      icon: <FaStethoscope />,
      description: "Foundation framework covering essential subjects for competitive exams.",
      exams: [
        "Mathematics",
        "English",
        "Aptitude",
        "Psychology"
      ]
    },
    {
      title: "Many More Programs",
      icon: <FaPlus />,
      description: "Explore our extensive range of specialized exam preparation programs.",
      exams: [
        "Government Job Exams",
        "Banking & Insurance",
        "State Services Exams",
        "And Many More..."
      ]
    }
  ];

  return (
    <div className="competitive-exams-page">
      <div className="exams-header">
        <div className="header-content">
          <h1>
            <span className="gradient-text">Expert Guidance</span>
            <span className="accent-text">For Every Exam</span>
          </h1>
          <div className="header-line"></div>
          <p className="subtitle">Comprehensive Preparation Programs for Defense Services and Competitive Examinations</p>
        </div>
      </div>

      <div className="exams-grid">
        {examCategories.map((category, index) => (
          <div className="exam-card" key={index}>
            <div className="exam-icon">
              {category.icon}
            </div>
            <h2 className="exam-title">{category.title}</h2>
            <p className="exam-description">{category.description}</p>
            <ul className="exam-list">
              {category.exams.map((exam, examIndex) => (
                <li key={examIndex}>{exam}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="exams-cta-section">
        <h2>Unlock Your Future: We Train for 50+ More Competitive Exams!</h2>
        <p>Ready to explore more opportunities? Contact us to discover our full range of exam preparation programs</p>
        <Link to="/contact" style={{ textDecoration: 'none' }}>
          <ShimmerButton className="cta-button">
            Contact Us Now <FaArrowRight className="arrow-icon" />
          </ShimmerButton>
        </Link>
      </div>
    </div>
  );
};

export default CompetitiveExams;
